(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
/* jquery for section load */
function ftrload() {
  $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 

        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {

        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }


      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
 
  }


$(document)
 .on( 'shopify:section:load', ftrload )
;
/* ends */

  $(document).ready(function() {
    $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      
     links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });
$( document ).ready(function() {
  (function($){
    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 
        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {
        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }

    $(window).load(function() {
      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
    });
  })(jQuery);
    });

  } catch(e) { console.error(e); }
})();
})();
